import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import FormCard from '../../components/CoPayCard/Form';
import Footnotes from '../../components/Footnotes';
import CallToAction from '../../components/CallToAction';
import BreadCrumbs from '../../components/Breadcrumbs';
import UnexpectedError from '../../components/UnexpectedError';

const Finish = (props) => {
  let content;
  let patientImageClass = '';

  // 406 - disqualified
  // 409 - already enrolled
  // 500 - server error
  if (props.enrollmentError) {
    if (props.enrollmentError === 409) {
      patientImageClass = 'smaller-patient-image';
      content = (() => {
        return (
          <div className="already-enrolled">
            <Header as="h1">
                Thank you for your request
            </Header>
            <div className="red-box ok">
              <p>The patient is <b>already enrolled</b> in the Takeda Oncology Co-Pay Assistance Program.</p>
            </div>
            <CallToAction id={ 4 }/>
          </div>
        );
      })();
    } else {
      content = (() => {
        return <UnexpectedError error={ props.enrollmentError } />;
      })();
    }
  }

  // active, inactive, pending, not eligible (not eligible will replace inactive/pending)
  if (props.enrollmentStatus) {
    switch (props.enrollmentStatus) {
      case 'ACTIVE':
        patientImageClass = 'success-pharma-card smaller-patient-image';
        content = (() => {
          return (
            <div className="success">
              <Header as="h1">
                Thank you
                <Header.Subheader className="poppins-regular">
                  Your patient has successfully enrolled in the Takeda Oncology Co-Pay Assistance Program. Your patient is eligible to pay as little as $0 per Takeda Oncology prescription.*<br/> Your patient can start using their card today.
                </Header.Subheader>
              </Header>
              <br/>
              <p>
                Below is an image of the card your patient will receive in the mail. They do not need the actual card
                to begin saving. Your patient may continue to use their original card as well, as the personal identification number has not changed.
              </p>
              <br/>
              <p><strong>Please use the information below to process your patient’s claim.</strong></p>
              <FormCard
                selectedProduct={ props.environment }
                cardBin={ props.cardBin }
                cardPcn={ props.cardPcn }
                cardId={ props.cardId }
                groupId={ props.groupId }
              />
              <CallToAction id={ 6 }/>
              <Footnotes footnotes={ [2.5, 3, 4] }/>
            </div>
          );
        })();
        break;
      case 'INACTIVE':
      case 'PENDING':
      case 'NOT ELIGIBLE':
        patientImageClass = 'smaller-patient-image';
        content = (() => {
          return (
            <div className="pending-verification">
              <Header as="h1">
                  Pending verification of your patient’s insurance
              </Header>
              <div className="red-box time">
                <p>Sorry we are still processing your request. More information may be required. Please call <strong>1&#8209;855&#8209;902&#8209;6725</strong> for further assistance.</p>
                <div>
                  <p>Please use the below reference ID number when calling.</p>
                  <p className="pending-id-number"><b>Reference ID Number = {props.cardId}</b></p>
                </div>
              </div>
              <CallToAction id={ 7 }/>
            </div>
          );
        })();
        break;
      default:
        content = <UnexpectedError code="Something went wrong" />;
    }
  }

  return (
    <div className={ `sign-up full-width pharma finish ${patientImageClass || ''}` }>
      <BreadCrumbs activeIndex={ 2 }/>
      <div className="wrapper">
        { content }
      </div>
    </div>
  );
};

Finish.propTypes = {
  environment: PropTypes.string.isRequired,
  cardId: PropTypes.string,
  cardBin: PropTypes.string,
  cardPcn: PropTypes.string,
  groupId: PropTypes.string,
  enrollmentStatus: PropTypes.string,
};

export default Finish;
